/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { DeploymentModeComponent } from './deployment-mode.component';
import { DeploymentModeService } from './deployment-mode.service';
import { DeploymentModeStrService } from './deployment-mode-str.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
    ],
    declarations: [DeploymentModeComponent],
    providers: [
        DeploymentModeService,
        DeploymentModeStrService,
    ],
    exports: [DeploymentModeComponent],
})
export class DeploymentModeModule { }
